require('./Container.css')
module.exports = require('./Container')



// WEBPACK FOOTER //
// ./src/components/Container/index.js